// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomModal from '../CustomModal/CustomModal';
import {colors} from '../../assets/styles/colors';
import domainChanged from '../../assets/img/domainChanged.png';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as CheckoutActions} from '../../modules/checkout/duck';
import type {CheckoutAction} from '../../modules/checkout/duck';
import type {Store, Country, User} from '../../entities';

import type {RootState} from '../../modules';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    isSubscribing: state.checkout.isSubscribing,
    subscribeSuccess: state.checkout.subscribeSuccess,
    country: state.country.country,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
      },
      dispatch
    )
)(DomainChangedModal);

type Props = {
  open: boolean,
  store?: Store,
  handleClose: () => void,
  freeTrialSubscribe: (payload: CheckoutAction) => void,
  isSubscribing?: boolean,
  subscribeSuccess?: boolean,
  checkoutResetState: () => void,
  country: Country,
  user?: User,
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 415,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
  },
  img: {
    height: 78,
    width: 78,
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '24px',
    marginTop: theme.spacing(2),
    // width: 232,
  },
  innerContent: {
    marginTop: theme.spacing(1),
    borderRadius: '12px',
    // backgroundColor: colors.grey200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    fontWeight: 500,
    color: colors.grey800,
    lineHeight: '1.75rem',
  },
  bold: {
    fontWeight: 700,
  },
  box: {
    width: '100%',
    marginTop: theme.spacing(2),
    backgroundColor: colors.grey200,
    padding: theme.spacing(1, 3),
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
  },
  boxContent: {
    margin: theme.spacing(0, -3),
    padding: theme.spacing(0, 3),
    overflowX: 'auto',
  },
  boxSubtitle: {
    marginTop: theme.spacing(0.5),
    color: colors.grey900,
    fontSize: '0.875rem',
    fontWeight: 600,
  },
  boxText: {
    marginTop: theme.spacing(0.5),
    color: colors.grey700,
    fontSize: '0.75rem',
  },
  divider: {
    width: '100%',
    marginTop: theme.spacing(2),
    background: colors.grey300,
  },
  sentEmailText: {
    margin: theme.spacing(2, 2, 1, 2),
    color: colors.purple3,
    fontWeight: 500,
    fontSize: '0.75rem',
    textAlign: 'center',
  },
  button: {
    height: 48,
    width: 300,
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    fontWeight: 600,
  },
  disclaimer: {
    marginTop: theme.spacing(2),
    color: colors.grey700,
    fontSize: '12px',
  },
}));

function DomainChangedModal(props: Props) {
  const {open, handleClose, user} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <img src={domainChanged} alt="star" className={classes.img} />
        <Typography className={classes.title}>
          ¡{user ? user.firstName : ''}!<br />
          Tu dominio fue modificado
        </Typography>
        <div className={classes.innerContent}>
          <Typography className={classes.text}>
            Recuerda que el link para tu panel administrativo también ha sido
            modificado.
          </Typography>
          <Typography className={`${classes.text} ${classes.bold}`}>
            Tus nuevos accesos son:
          </Typography>
        </div>
        <div className={classes.box}>
          <div className={classes.boxContent}>
            <Typography className={classes.boxSubtitle}>
              Panel administrativo:
            </Typography>
            <Typography className={classes.boxText}>
              {window.location.origin}/admin
            </Typography>
            <Typography className={classes.boxSubtitle}>
              Link de tienda:
            </Typography>
            <Typography className={classes.boxText}>
              {window.location.origin}
            </Typography>
          </div>
          <Divider className={classes.divider} />
          <Typography className={classes.sentEmailText}>
            Te enviamos un correo con tu nuevo acceso.
          </Typography>
        </div>
        <CustomButton
          variant="contained"
          className={classes.button}
          onClick={handleClose}
        >
          Cerrar
        </CustomButton>
        <Divider className={classes.divider} />
        <Typography className={classes.disclaimer}>
          *Tu correo de acceso y contraseña se mantiene igual
        </Typography>
      </div>
    </CustomModal>
  );
}

DomainChangedModal.propTypes = {
  store: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  freeTrialSubscribe: PropTypes.func.isRequired,
  subscribeSuccess: PropTypes.bool,
  checkoutResetState: PropTypes.func.isRequired,
  country: PropTypes.object,
  user: PropTypes.object,
};
